import React from "react"
import ServicePage from "@components/Site/ServicePage"
import BubblesBg from "@components/Site/BubblesBg/BubblesBg"


export default function () {
  return <>
    <ServicePage id="terms" />
    <BubblesBg />
  </>
}